<template lang="pug">
    div
        v-list(dense)

            v-list-item(ripple link to="/")
                v-list-item-action
                    v-icon mdi-home
                v-list-item-content
                    v-list-item-title Home

            //- v-list-item(ripple link :href="railsVolieBaseUrl + '/call_screen'")
            //-     v-list-item-action
            //-         v-icon mdi-phone
            //-     v-list-item-content
            //-         v-list-item-title Call Screen

            v-list-item(ripple link to="/communication_center")
                v-list-item-action
                    v-icon mdi-headphones
                v-list-item-content
                    v-list-item-title Communication Center

            v-list-group(prepend-icon='mdi-poll' no-action style="color: var(--white) !important;")
                template(v-slot:activator)
                    v-list-item-content(style="height: 48px;")
                        v-list-item-title Dashboard

                v-list-item(ripple link :to="{path: '/dashboards/affinity-dashboard'}")
                    v-list-item-title Affinity
                    v-list-item-action
                        v-icon mdi-link-variant

                v-list-item(ripple link :to="{path: '/dashboards/appointment-dashboard'}")
                    v-list-item-title Appointment
                    v-list-item-action
                        v-icon mdi-calendar-month

                v-list-item(ripple link :to="{path: '/dashboards/big-board'}")
                    v-list-item-title Big Board
                    v-list-item-action
                        v-icon mdi-view-dashboard

                v-list-item(ripple link :to="{path: '/dashboards/lead-dashboard'}")
                    v-list-item-title Lead
                    v-list-item-action
                        v-icon mdi-folder-account

                v-list-item(ripple link :to="{path: '/dashboards/live-dashboard'}")
                    v-list-item-title Live
                    v-list-item-action
                        v-icon mdi-sync

            v-list-group(prepend-icon='mdi-cog' no-action style="color: var(--white) !important;")
                template(v-slot:activator)
                    v-list-item-content(style="height: 48px;")
                        v-list-item-title Management

                //- v-list-item(ripple link to="/agent_visibility")
                //-     v-list-item-title Agent Visibility
                //-     v-list-item-action
                //-         v-icon mdi-account-group

                v-list-item(ripple link :href="railsVolieBaseUrl + '/call_campaign_management'")
                    v-list-item-title Call Campaign
                    v-list-item-action
                        v-icon mdi-cog

                v-list-item(ripple link :to="{ name: 'campaign_attempt_management' }")
                    v-list-item-title Campaign Attempt
                    v-list-item-action
                        v-icon mdi-counter

                v-list-item(ripple link to="/campaign_deployments")
                    v-list-item-title Campaign Deployments
                    v-list-item-action
                        v-icon mdi-rocket-launch

                v-list-item(v-if="alertsV2Enabled" ripple link to="/alerts")
                    v-list-item-title Alerts
                    v-list-item-action
                        v-icon mdi-alert-circle
                v-list-item(v-else ripple link :href="railsVolieBaseUrl + '/hot_alerts'")
                    v-list-item-title Hot Alerts
                    v-list-item-action
                        v-icon mdi-alert-circle

                v-list-item(v-if="showWorkplansNav" ripple link :href="workplansFrontendUrl" rel="noopener noreferrer")
                    v-list-item-title Workplan
                    v-list-item-action
                        v-icon mdi-list-box-outline

            v-list-item(ripple link to="/organizations")
                v-list-item-action
                    v-icon mdi-office-building
                v-list-item-content
                    v-list-item-title Organizations

            v-list-item(ripple link :href="pulseV2BaseUrl")
                v-list-item-action
                    PulseColorIcon(:size="35" style="margin-left: -4px")
                v-list-item-content(style="margin-left: -6px")
                    v-list-item-title Pulse

            v-list-item(ripple link to="/reports")
                v-list-item-action
                    v-icon mdi-folder-open
                v-list-item-content
                    v-list-item-title Reports

            v-list-group(prepend-icon='mdi-magnify' no-action style="color: var(--white) !important;")
                template(v-slot:activator)
                    v-list-item-content(style="height: 48px;")
                        v-list-item-title Search

                v-list-item(ripple link :href="railsVolieBaseUrl + '/appointments'")
                    v-list-item-title Appointments
                    v-list-item-action
                        v-icon mdi-calendar-month

                v-list-item(ripple link to="/calls")
                    v-list-item-title Calls
                    v-list-item-action
                        v-icon mdi-phone

                v-list-item(ripple link to="/customer_search")
                    v-list-item-title Customers
                    v-list-item-action
                        v-icon mdi-account-group

                v-list-item(ripple link :href="railsVolieBaseUrl + '/emails'")
                    v-list-item-title Emails
                    v-list-item-action
                        v-icon mdi-email

                v-list-item(ripple link :href="railsVolieBaseUrl + '/employees'")
                    v-list-item-title Employees
                    v-list-item-action
                        v-icon mdi-account-group

                v-list-item(ripple link to="/missed_calls")
                    v-list-item-title Missed Calls
                    v-list-item-action
                        v-icon mdi-voicemail

                v-list-item(ripple link :href="pulseV2BaseUrl")
                    v-list-item-action
                        PulseColorIcon(:size="35" style="margin-left: -4px")
                    v-list-item-content(style="margin-left: -6px")
                        v-list-item-title Pulse

                v-list-item(ripple link :href="railsVolieBaseUrl + '/call_queue_log_ins'")
                    v-list-item-title Queue Log Ins
                    v-list-item-action
                        v-icon mdi-clipboard-list

                v-list-item(ripple link :href="railsVolieBaseUrl + '/surveys'")
                    v-list-item-title Surveys
                    v-list-item-action
                        v-icon mdi-pencil-box

                v-list-item(ripple link :to="{ name: 'survey_attempts_index' }")
                    v-list-item-title Survey Attempts
                    v-list-item-action
                        v-icon mdi-counter

            v-list-item(v-if="!hideTickets" ripple link to="/tickets")
                v-list-item-action
                    v-icon mdi-ticket-outline
                v-list-item-content
                    v-list-item-title Tickets

            v-list-item(ripple link :href="railsVolieBaseUrl + '/users'")
                v-list-item-action
                    v-icon mdi-account-group
                v-list-item-content
                    v-list-item-title Users

        v-divider

        v-list(dense)
            v-list-item(ripple :to="`/users/${currentUser.user_key}/edit`")
                v-list-item-action
                    v-icon mdi-account
                v-list-item-content
                    v-list-item-title Profile

            v-list-item(ripple link :href="'/api_docs'")
                v-list-item-action
                    v-icon mdi-notebook
                v-list-item-content
                    v-list-item-title Api Docs

            v-list-item(ripple link href="https://intercom.help/volie/en" target="_blank")
                v-list-item-action
                    v-icon mdi-help-circle
                v-list-item-content
                    v-list-item-title Help

            //- v-list-item(ripple link to="/privacy_policy")
            //-     v-list-item-action
            //-         v-icon mdi-security
            //-     v-list-item-content
            //-         v-list-item-title Privacy Policy

            //- v-list-item(ripple link to="/terms_and_conditions")
            //-     v-list-item-action
            //-         v-icon mdi-clipboard-text
            //-     v-list-item-content
            //-         v-list-item-title Terms and Conditions

            v-list-item(ripple link :href="railsVolieBaseUrl + '/log_out'")
                v-list-item-action
                    v-icon mdi-logout
                v-list-item-content
                    v-list-item-title Logout

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState from '@/store';
    import { CheckFeatureFlag } from '@/data/feature_flag_check';
    import { FeatureFlags } from '@/constants/feature_flags';

    import PulseColorIcon from '@/components/scorecards/pulse_color_icon.vue';

    export default Vue.extend({
        data() {
            return {
                alertsV2Enabled: false,
                workplansManagementEnabled: false,
            }
        },
        methods: {
        },
        computed: {
            currentUser() {
                return VolieState.currentUser();
            },
            railsVolieBaseUrl() {
                return VolieState.baseRailsUrl();
            },
            pulseV2BaseUrl() {
                return VolieState.basePulseV2Url();
            },
            workplansFrontendUrl() {
                return this.pulseV2BaseUrl + '/workplan';
            },
            hideTickets() {
                return this.currentUser?.account?.intercom_enabled || false;
            },
            showWorkplansNav() {
                return this.workplansManagementEnabled && this.currentUser?.account?.workplans_enabled === true;
            },
        },
        components: {
            PulseColorIcon,
        },
        props: {
        },
        watch: {
            'currentUser.activated_account_id'() {
                CheckFeatureFlag(FeatureFlags.AlertsV2).then(enabled => {
                    this.alertsV2Enabled = enabled;
                });
                CheckFeatureFlag(FeatureFlags.WorkplansNavLink).then(enabled => {
                    this.workplansManagementEnabled = enabled;
                });
            },
        },
        created() {
            CheckFeatureFlag(FeatureFlags.AlertsV2).then(enabled => {
                this.alertsV2Enabled = enabled;
            });
            CheckFeatureFlag(FeatureFlags.WorkplansNavLink).then(enabled => {
                this.workplansManagementEnabled = enabled;
            });
        },
    });
</script>

<style lang="scss" scoped>
</style>
